import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useSLA } from '@/features/SLAs/useSLA'
import SLAForm from '../components/SLAForm'

const EditSLA = () => {
  const { id } = useParams()

  const { useUpdateSLA, useFetchSLA } = useSLA()

  const updateSLA = useUpdateSLA()
  const navigate = useNavigate()

  const { data: SLA } = useFetchSLA(id)

  const onSubmit = async ({ id, ...rest }) => {
    console.log('In Edit SLA Page: ', rest)
    updateSLA.mutate(
      { id, data: rest },
      {
        onSuccess: () => {
          navigate('/admin/SLAs/')
        },
      }
    )
  }

  console.log(SLA)

  return <SLAForm onSubmitAction={onSubmit} SLA={SLA} />
}

export default EditSLA
